document.addEventListener("DOMContentLoaded", function () {
  const cachedData = {};

  document.addEventListener("click", function (event) {
    const button = event.target.closest("[data-variant-toggle]");
    if (!button) {
      return;
    }

    const destination = button.closest(".collection-item");
    if (!destination) {
      return;
    }

    const baseUrl = button.getAttribute("data-variant-toggle");
    const separator = baseUrl.includes("?") ? "&" : "?";
    const fetchUrl = baseUrl + separator + "sections=collection-product";
    const cacheKey = fetchUrl;

    if (cachedData[cacheKey]) {
      destination.innerHTML = cachedData[cacheKey];
      return;
    }

    destination.classList.add("loading");

    fetch(fetchUrl)
      .then(function (response) {
        return response.json();
      })
      .then(function (responseData) {
        var source = responseData["collection-product"];
        if (source) {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = source;

          const newItem = tempDiv.querySelector(".collection-item");
          if (newItem) {
            const innerContent = newItem.innerHTML.trim();
            cachedData[cacheKey] = innerContent;
            destination.innerHTML = innerContent;
          } else {
            console.error(
              "Failed to find .collection-item in fetched content."
            );
          }
        } else {
          console.error("Failed to find source for product.");
        }
      })
      .catch(function (error) {
        console.error("Error loading the product content:", error);
      })
      .finally(function () {
        setTimeout(() => {
          destination.classList.remove("loading");
        }, 100);
      });
  });
});
